import React from "react";

/**
 * Draws the recorded equity curve. When there is not enough real history the
 * section keeps its place and says so instead of drawing a decorative line.
 */
export function GoldBotEquityCurve({ curve, emptyMessage }) {
  if (!curve.hasCurve) {
    return (
      <div className="goldbot-chart-placeholder">
        <span>{emptyMessage}</span>
      </div>
    );
  }

  return (
    <div className="goldbot-chart">
      <svg
        className="goldbot-chart__svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        role="img"
        aria-label={`Equity curve from ${curve.firstLabel} to ${curve.lastLabel}`}
      >
        <path className="goldbot-chart__area" d={curve.area} />
        <path
          className="goldbot-chart__line"
          d={curve.line}
          vectorEffect="non-scaling-stroke"
        />
      </svg>
      <div className="goldbot-chart__meta">
        <span>{curve.basisLabel}</span>
        <span>
          {curve.firstLabel} → {curve.lastLabel}
        </span>
      </div>
    </div>
  );
}

export default GoldBotEquityCurve;
